module.exports = __webpack_public_path__ + "static/img/SB.3432024.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poker/SB.jpeg
// module id = 9rIe
// module chunks = 2